export default __webpack_public_path__ + "static/media/ic-cash.230be6a5.svg";